import { render, staticRenderFns } from "./FXRate.vue?vue&type=template&id=2204a590&"
import script from "./FXRate.vue?vue&type=script&lang=js&"
export * from "./FXRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports